import loadable from '@loadable/component';

export const OrgDashboardCreateInternshipPageLoadable = loadable(
  () => import('./OrgDashboardCreateInternshipPage'),
  { resolveComponent: (module) => module.OrgDashboardCreateInternshipPage },
);
